{
  "acceptedFileFormats": "Es werden nur Dateien im Format .docx, .pdf und .txt akzeptiert.",
  "actionCompetenceGroup": "Aktions-Kompetenzgruppe",
  "actionDeadline": "Aktionsfrist",
  "actionDescription": "Aktionsbeschreibung",
  "actionDuration": "Aktionsdauer",
  "actionEarliestStart": "Frühester Start der Aktion",
  "actionName": "Aktionsname",
  "actions": "Aktionen",
  "actionsAndProjects": "Aktionen & Projekte",
  "actionsColon": "Aktionen: ",
  "actionsPerformerConstraints": "Ausführenden-Beschränkungen für Aktionen",
  "add": "Hinzufügen",
  "addAdmin": "Admin hinzufügen",
  "addAdminTitle": "Admin hinzufügen",
  "addAnalyses": "Analysen hinzufügen",
  "addAnalysis": "Analyse hinzufügen",
  "addAnalysisGroup": "Analysegruppe hinzufügen",
  "addChatbot": "Chatbot hinzufügen",
  "addCompetenceGroup": "Kompetenzgruppe hinzufügen",
  "addConstraint": "Beschränkung hinzufügen",
  "addGreyTask": "GreyTask hinzufügen",
  "addInstrument": "Instrument hinzufügen",
  "addItemPlaceholder": "{{item}} hinzufügen...",
  "addLocation": "Standort hinzufügen",
  "addMaintenance": "Wartung hinzufügen",
  "addMember": "Mitglied hinzufügen",
  "addNewBundle": "Neues Bundle hinzufügen",
  "addNewMaintenanceFor": "Neue Wartung für {{assetName}} hinzufügen",
  "addNewTask": "Neue Aufgabe hinzufügen",
  "addOffsite": "OFFSITE hinzufügen",
  "addProjectGroup": "Projektgruppe hinzufügen",
  "addProjectTemplate": "Projektvorlage hinzufügen",
  "addRepository": "Repository hinzufügen",
  "addRow": "Zeile hinzufügen",
  "addSample": "Probe hinzufügen",
  "addSamples": "Proben hinzufügen",
  "addTeam": "Team hinzufügen",
  "additionalInformation": "Zusätzliche Informationen",
  "administrators": "Administratoren",
  "advanced": "Erweitert",
  "allFilesProcessed": "Alle hochgeladenen Dateien wurden verarbeitet",
  "allowMembersMoveOthersOperationalTasks": "Mitgliedern erlauben, operative Aufgaben anderer zu verschieben",
  "allowedCompetenceGroups": "Erlaubte Kompetenzgruppen",
  "allowedInstruments": "Erlaubte Instrumente",
  "amountOfSamples": "Anzahl der Proben: {{count}}",
  "analyses": "Analysen",
  "analysesRelatedTo": "Analysen bezogen auf {{product}}",
  "analysis": "Analyse",
  "analysisAndSampleDone": "Die Analyse und die Probe sind abgeschlossen",
  "analysisDefinition": "Analysedefinition",
  "analysisDesignTool": "Analyse-Design-Tool",
  "analysisDone": "Die Analyse ist abgeschlossen",
  "analysisDraft": "Analyse-ENTWURF",
  "analysisGroup": "Analysegruppe",
  "analysisGroupName": "Name der Analysegruppe",
  "analysisIsFlagged": "Analyse ist markiert",
  "analysisMustContainTaskDefinition": "Die Analyse muss eine Aufgabendefinition enthalten",
  "analysisName": "Analyse-Name",
  "analysisNameMustBeUnique": "Der Analyse-Name muss eindeutig sein",
  "analysisNotPlanned": "Diese Analyse ist nicht geplant",
  "analysisPlanned": "Diese Analyse ist geplant",
  "analysisTaskBundle": "Analyseaufgaben-Bundle {{index}}",
  "cdmoTargetedBundle": "Aufgaben nach Analysename zusammenfassen",
  "analysisTaskTimePerformerSamples": "Analyseaufgabe - Zeit, Ausführender, Anzahl der Proben",
  "analysisTasks": "Analyseaufgaben",
  "analysisTasksToBundle": "Zu bündelnde Analyseaufgaben",
  "analysisTimePercentage": "Prozentsatz der Analysezeit im Verhältnis zur Gesamtzeit (A2T)",
  "anywhere": "Beliebig",
  "apiToken": "API-Token",
  "archiveMember": "Mitglied archivieren",
  "archived": "archiviert",
  "areYouSureConnection": "Sind Sie sicher, dass Sie diese Verbindung möchten?",
  "areYouSureConnectionMode": "Sind Sie sicher, dass Sie in den Modus \"mit Verbindung\" wechseln möchten? Dadurch werden alle aktuellen Verbindungen entfernt",
  "areYouSureDeleteAdmin": "Sind Sie sicher, dass Sie diesen Admin löschen möchten?",
  "areYouSureDiscardSimulation": "Sind Sie sicher, dass Sie die im Simulationsmodus vorgenommenen Änderungen verwerfen möchten?",
  "areYouSurePublishSimulation": "Sind Sie sicher, dass Sie die im Simulationsmodus vorgenommenen Änderungen veröffentlichen möchten?",
  "areYouSureReset": "Sind Sie sicher, dass Sie zurücksetzen möchten? Dadurch werden alle Knoten entfernt.",
  "areYouSureUnplanAllFutureActions": "Sind Sie sicher, dass Sie alle zukünftigen Aktionen in diesem Projekt aus der Planung entfernen möchten?",
  "areYouSureWantToExit": "Sind Sie sicher, dass Sie beenden möchten?",
  "arrival": "Ankunft",
  "assetAddedOrRemoved": "Asset wurde hinzugefügt oder entfernt",
  "assetRequirementsForAsset": "Asset-Anforderungen für Asset {{index}}",
  "assets": "Assets",
  "atLeast1LowercaseLetter": "mindestens 1 Kleinbuchstabe",
  "atLeast1Number": "mindestens 1 Zahl",
  "atLeast1UppercaseLetter": "mindestens 1 Großbuchstabe",
  "atLeast8Characters": "mindestens 8 Zeichen",
  "automaticImportConversionSheet": "Automatisches {{type}}-Import-Konvertierungsblatt",
  "automaticSheetConfiguration": "Automatische Blattkonfiguration",
  "availability": "Verfügbarkeit",
  "availableTimeOneWeek": "Verfügbare Zeit in einer Woche: ",
  "avgAnalysisDuration": "Durchschnittliche Analysedauer: ",
  "avgSampleBatchInterval": "Durchschnittliches Probenchargen-Intervall: ",
  "avgSamplesAllocated": "Durchschnittliche Anzahl zugewiesener Proben: ",
  "backlog": "Backlog",
  "booked": "Gebucht",
  "bookedBy": "Gebucht von",
  "byCompetenceGroup": "Nach Kompetenzgruppe",
  "byDeadline": "Nach Frist",
  "byGroup": "Nach Gruppe",
  "byText": "Nach Text",
  "canBePerformedAnywhere": "Kann überall ausgeführt werden",
  "canOnlyBePerformedOnSite": "Kann nur vor Ort ausgeführt werden",
  "cancel": "Abbrechen",
  "cancelChanges": "Änderungen abbrechen",
  "cannotUnlockStartedTasks": "Sie können dies nicht entsperren, da eine oder mehrere Aufgaben gestartet, pausiert oder abgeschlossen sind",
  "changeLogs": "Änderungsprotokolle",
  "changesHaveBeenMade": "Es wurden Änderungen vorgenommen, bitte für neue Daten neu laden",
  "chatbotGreeting": "Hallo, ich bin Ihr KI-CHATBOT, spezialisiert auf die Plannertech- und Librarian-Hilfedokumentation sowie die Daten-Repositories, die Sie importiert haben.\nSie können sich auch jederzeit von 9-16 CET an unseren menschlichen Support unter pt@arnvind.com wenden.\nWie kann ich Ihnen helfen? :-)",
  "chatbotName": "Chatbot-Name",
  "chatbotPlaceholder": "Schreiben Sie eine kurze Beschreibung dazu, wie sich der Chatbot verhalten soll.",
  "chatbots": "Chatbots",
  "chattingWith": "Chat mit {{name}}",
  "chooseAction": "Aktion wählen",
  "chooseTask": "Aufgabe wählen",
  "chooseWhatToAdd": "Wählen Sie, was Sie hinzufügen möchten",
  "cleanUp": "Bereinigen",
  "clear": "Leeren",
  "clearConversation": "Konversation leeren",
  "clearDates": "Daten leeren",
  "clearTable": "Tabelle leeren",
  "clickToSelectOtherFiles": "Klicken Sie, um andere Dateien auszuwählen",
  "close": "Schließen",
  "closeMessage": "Nachricht schließen",
  "closePanel": "Panel schließen",
  "collaborator": "Mitarbeitender",
  "collaborators": "Mitarbeitende",
  "domain": "Domain",
  "color": "Farbe",
  "columnName": "Spaltenname",
  "companyWideChatbot": "Unternehmensweiter Chatbot",
  "competenceAndInstrumentConstraints": "Kompetenz- und Instrumentbeschränkungen",
  "competenceGroup": "Kompetenzgruppe",
  "competenceGroupNameExists": "Eine Kompetenzgruppe mit diesem Namen existiert bereits",
  "competenceGroups": "Kompetenzgruppen",
  "competenceGroupsColon": "Kompetenzgruppen: ",
  "configuration": "Konfiguration",
  "confirm": "Bestätigen",
  "confirmArchivalOfMember": "Archivierung des Mitglieds bestätigen: {{initials}}",
  "confirmClearTable": "Sind Sie sicher, dass Sie die Tabelle leeren möchten?",
  "confirmDeleteAllData": "Wenn Sie dies bestätigen, werden alle {{type}}-Daten gelöscht. Es gibt kein Zurück, auch nicht mit dem Simulationsmodus.",
  "confirmDeleteAllUnplannedProjects": "Wenn Sie dies bestätigen, werden alle Projekte gelöscht, die keine im Plan platzierten Aktionen haben",
  "confirmDeleteAllUnplannedSamples": "Wenn Sie dies bestätigen, werden alle Proben gelöscht, die keine im Plan platzierten Aktionen haben",
  "confirmDeleteCompetenceGroup": "Löschung der Kompetenzgruppe bestätigen:",
  "confirmDeleteInstrument": "Sind Sie sicher, dass Sie Instrument {{name}} löschen möchten?",
  "confirmDeleteMaintenance": "Sind Sie sicher, dass Sie diese Wartung löschen möchten?",
  "confirmDeleteSample": "Sind Sie sicher, dass Sie diese ungeplante Probe löschen möchten?",
  "confirmDeleteSampleInfo": "Wenn Sie dies bestätigen, wird die ausgewählte Probe dauerhaft gelöscht",
  "confirmDeletion": "Löschung bestätigen",
  "confirmFailSamples": "Sind Sie sicher, dass Sie die ausgewählten Proben als fehlgeschlagen markieren möchten?",
  "confirmFailSamplesInfo": "Wenn Sie dies bestätigen, werden ausgewählte Proben als fehlgeschlagen markiert. Ein Duplikat wird im Menü für ungeplante Analysen abgelegt",
  "confirmFailSamplesQuestion": "Sind Sie sicher, dass Sie die ausgewählten Proben als fehlgeschlagen markieren möchten?",
  "confirmShowPlannedSamplesInfo": "Wenn Sie dies bestätigen, werden geplante Proben angezeigt",
  "confirmShowPlannedSamplesQuestion": "Sind Sie sicher, dass Sie geplante Proben anzeigen möchten?",
  "confirmSortByTime": "Sind Sie sicher, dass Sie nach Zeit sortieren möchten",
  "confirmUnplanAllFutureActions": "Sind Sie sicher, dass Sie alle zukünftigen Aktionen in diesem Projekt aus der Planung entfernen möchten?",
  "confirmUnplanAllQuestion": "Sind Sie sicher, dass Sie alle {{itemType}} aus der Planung entfernen möchten?",
  "confirmUnplanSamplesInfo": "Wenn Sie dies bestätigen, werden ausgewählte Proben aus der Planung entfernt. Sie werden im Menü für ungeplante Analysen abgelegt",
  "confirmUnplanSamplesQuestion": "Sind Sie sicher, dass Sie die ausgewählten Proben aus der Planung entfernen möchten?",
  "connectionCalculatedInWorkdays": "Verbindung in Arbeitstagen berechnet",
  "connectionCount": "Anzahl Verbindungen",
  "connections": "Verbindungen",
  "connectionsAdvancedWarning": "(Verbindungen mit Frist oder frühestem Start bei Aktionen sind für fortgeschrittene Benutzer gedacht)",
  "connectionsPerformersOnly": "Verbindungen betreffen nur Ausführende - sie beeinflussen nicht die Asset-Zuweisung",
  "contactArnvindSupport": "Bitte kontaktieren Sie den Arnvind-Support unter pt@arnvind.com",
  "conversionSheet": "Konvertierungsblatt",
  "copyToClipboard": "in die Zwischenablage kopieren",
  "country": "Land",
  "create": "Erstellen",
  "createANewColumn": "Neue Spalte erstellen",
  "createAction": "Aktion erstellen",
  "createChatbot": "Chatbot erstellen",
  "createEditChatbots": "Chatbots erstellen/bearbeiten",
  "createEditRepositories": "Repositories erstellen/bearbeiten",
  "createNewColumn": "Neue Spalte erstellen",
  "createNewProject": "Neues Projekt erstellen",
  "createSingleAction": "Einzelne Aktion erstellen",
  "createStage": "Phase erstellen",
  "createStandardAction": "Standardaktion erstellen",
  "currentlyProcessingRepository": "Dieses Repository wird derzeit verarbeitet",
  "daily": "Täglich",
  "date": "Datum",
  "dateUnavailable": "Datum nicht verfügbar",
  "day": "Tag",
  "dayS": "Tag(e)",
  "days": "Tag(e)",
  "daysBeforeExpirationWarning": "Tage vor Ablauf, ab denen eine Warnung angezeigt wird",
  "daysBetweenRecurrences": "Tage zwischen Wiederholungen",
  "deadline": "Frist",
  "deadlineColon": "Frist: ",
  "deadlineDate": "Fristdatum",
  "deadlineMustBeLaterThanEarliestStart": "Die Frist muss später als oder gleich dem frühesten Start sein",
  "deadlineTime": "Fristzeit",
  "defaultChatbot": "Standard-Chatbot",
  "delete": "Löschen",
  "deleteAllTypeTestData": "Alle {{type}}-Testdaten löschen",
  "deleteAllUnplannedProjects": "Alle ungeplanten Projekte löschen",
  "deleteAllUnplannedSamples": "Alle ungeplanten Proben löschen",
  "deleteColumn": "Spalte löschen",
  "deleteCompetenceGroup": "Kompetenzgruppe löschen",
  "deleteCompetenceGroupWarning": "Wenn Sie dies löschen, bleiben Aufgaben in den folgenden Analysen ohne Kompetenzgruppe. Stellen Sie vor dem Entfernen einen Ersatz sicher.",
  "deleteConstraint": "Beschränkung löschen",
  "deleteData": "Daten löschen",
  "deleteInstrument": "Instrument löschen",
  "deleteInstrumentWarning": "Es wird auch für andere Teams an diesem Standort gelöscht.",
  "deleteProjects": "Projekte löschen",
  "deleteSample": "Probe löschen",
  "deleteSamples": "Proben löschen",
  "deleteThisRow": "Diese Zeile löschen",
  "description": "Beschreibung",
  "designTool": "Design-Tool",
  "done": "Erledigt",
  "draft": "Entwurf",
  "dragAndDropFiles": "Dateien hierher ziehen und ablegen oder klicken, um Dateien auszuwählen",
  "dragAndDropFolders": "Ordner hierher ziehen und ablegen oder klicken, um bestimmte Dateien auszuwählen",
  "dropFilesHere": "Dateien hier ablegen",
  "dropFoldersHere": "Ordner hier ablegen...",
  "duplicate": "Duplizieren",
  "durationHHMM": "Dauer (HH:MM)",
  "earliestStart": "Frühester Start",
  "edit": "Bearbeiten",
  "editAction": "Aktion bearbeiten",
  "editAdmin": "Admin bearbeiten",
  "editAnalysisGroup": "Analysegruppe bearbeiten",
  "editAnalysisTask": "Analyseaufgabe bearbeiten",
  "editChatbot": "Chatbot bearbeiten",
  "editCompetenceGroup": "Kompetenzgruppe bearbeiten",
  "editConnectionFromTo": "Verbindung von {{from}} nach {{to}} bearbeiten",
  "editConversation": "Konversation bearbeiten",
  "editGroup": "Gruppe bearbeiten",
  "editInstrument": "Instrument bearbeiten",
  "editItem": "{{item}} bearbeiten",
  "editLocationName": "Standortname bearbeiten",
  "editMaintenanceFor": "{{name}} für {{assetName}} bearbeiten",
  "editMember": "Mitglied bearbeiten",
  "editOffsite": "OFFSITE bearbeiten",
  "editProject": "Projekt bearbeiten",
  "editProjectGroup": "Projektgruppe bearbeiten",
  "editProjectTemplate": "Projektvorlage bearbeiten",
  "editProjectTemplateDraft": "Projektvorlagen-ENTWURF bearbeiten",
  "editRepository": "Repository bearbeiten",
  "editSampleName": "Probe bearbeiten: {{name}}",
  "editSheet": "Blatt {{name}} bearbeiten",
  "editStandardAction": "Standardaktion bearbeiten",
  "editTask": "Aufgabe bearbeiten",
  "editTeam": "Team bearbeiten",
  "edited": "Bearbeitet",
  "email": "E-Mail",
  "emailCannotContainDoubleDots": "E-Mail darf kein '..' enthalten",
  "emailLabel": "E-Mail",
  "endDate": "Enddatum",
  "enterSimulationMode": "Simulationsmodus starten",
  "errors": "Fehler",
  "errorsProcessingRepository": "Bei der Verarbeitung dieses Repositorys sind Fehler aufgetreten",
  "estimatedWorkloadOneWeek": "Geschätzte Arbeitslast in einer Woche: ",
  "exclusive": "Exklusiv",
  "exclusiveSampleIndicator": "* kennzeichnet eine exklusive Probe",
  "exitSimulation": "SIMULATION BEENDEN",
  "exitSimulationMode": "Simulationsmodus beenden",
  "expand": "Erweitern",
  "exportToExcel": "Nach Excel exportieren",
  "fail": "Fehlschlagen",
  "failSample": "Probe fehlschlagen lassen",
  "failSelected": "Ausgewählte fehlschlagen lassen",
  "failedLoading": "Laden fehlgeschlagen: {{members}}",
  "failedToCreateMaintenance": "Wartung \"{{name}}\" konnte nicht erstellt werden",
  "failedToDeleteMaintenance": "Wartung \"{{name}}\" konnte nicht gelöscht werden",
  "failedToMarkMaintenanceAsCompleted": "Wartung \"{{name}}\" konnte nicht als abgeschlossen markiert werden",
  "failedToUpdateMaintenance": "Wartung \"{{name}}\" konnte nicht aktualisiert werden",
  "failedUploads": "Fehlgeschlagene Uploads",
  "fileUpload": "Datei-Upload",
  "fileUploadError": "Beim Datei-Upload ist ein Fehler aufgetreten",
  "filenameLabel": "Dateiname: ",
  "filesUploadedSuccessfully": "Dateien erfolgreich hochgeladen",
  "fillIn": "Auffüllen",
  "fillInIgnoreOverbooking": "Auffüllen und Überbuchung ignorieren",
  "filter": "Filter",
  "filterByName": "Nach Namen filtern",
  "filterBySampleName": "Nach Probennamen filtern",
  "filterBySampleProductName": "Nach Proben-/Produktnamen filtern",
  "filterByText": "Nach Text filtern",
  "finished": "Abgeschlossen",
  "flag": "Markieren",
  "flagSample": "Probe markieren",
  "followingErrorsWhileImporting": "Folgende Fehler beim Importieren:",
  "free": "Frei",
  "from": "Von",
  "fromDate": "Von-Datum",
  "fromTime": "Von-Zeit (HH:MM)",
  "fromTimeHH": "Von-Zeit (HH)",
  "fromTimeHHMM": "Von-Zeit (HH:MM)",
  "futureAnalysisTaskCantBe": "Eine zukünftige Analyseaufgabe kann nicht {{state}} sein",
  "generate": "Generieren",
  "globalChatbot": "Globaler Chatbot",
  "goBack": "Zurück",
  "goBackToChat": "Zurück zum Chat",
  "greyTaskTimePercentage": "Prozentsatz der GreyTask-Zeit im Verhältnis zur Gesamtzeit (G2T)",
  "groupMembers": "Gruppenmitglieder",
  "groupName": "Gruppenname",
  "help": "Hilfe",
  "helpBackToApp": "Zurück zur App",
  "helpHome": "Hilfe-Startseite",
  "helpPageNotFound": "Hilfeseite nicht gefunden",
  "helpSearch": "Hilfe durchsuchen",
  "helpAppTitle": "Plannertech Hilfe",
  "hidden": "Verborgen",
  "hideMore": "Weniger anzeigen",
  "highestPriority": "1 ist die höchste Priorität",
  "history": "Verlauf",
  "home": "Startseite",
  "hour": "Stunde",
  "iCalendarOutlookIntegration": "iCalendar / Outlook-Integration",
  "iap": "IAP",
  "ignoreAllGreytasks": "Alle GreyTasks ignorieren",
  "ignoredByIap": "Von IAP ignoriert",
  "includingToday": "Einschließlich heute",
  "importedTask": "Importierte Aufgabe",
  "busyOnAnotherTeam": "Beschäftigt in einem anderen Team",
  "includeDoneSamples": "Abgeschlossene Proben einschließen",
  "includeOverdue": "Überfällige einschließen",
  "includeToday": "Heute einschließen",
  "iapIncludeTodayWarningIAP": "Warnung zu IAP und Heute einschließen - früher heute geplante Aufgaben können ebenfalls verschoben werden, sofern sie nicht gesperrt sind!",
  "iapIncludeTodayWarningFillIn": "Warnung zu Auffüllen und Heute einschließen - früher heute geplante Aufgaben können ebenfalls neue Proben zugewiesen bekommen!",
  "initials": "Initialen",
  "inputLastMonth": "Eingang letzter Monat",
  "inputThisMonth": "Eingang diesen Monat",
  "instrument": "Instrument",
  "instrumentConstraints": "Instrumentbeschränkungen",
  "instrumentLog": "Instrumentprotokoll",
  "instrumentName": "Instrumentname",
  "instrumentOffset": "Instrumentversatz (HH:MM)",
  "instrumentOverbooking": "Instrument-Überbuchung",
  "instrumentPerSampleDuration": "Instrumentdauer pro Probe (HH:MM:SS)",
  "instrumentSetup": "Instrumenteinrichtung {{name}}",
  "instrumentSetuptime": "Instrument-Rüstzeit (HH:MM)",
  "instrumentTime": "Instrumentzeit",
  "instrumentView": "Instrumentansicht",
  "instruments": "Instrumente",
  "instrumentsWithExpiredMaintenance": "Es gibt Instrumente mit abgelaufener Wartung",
  "instrumentsWithMaintenanceReminders": "Es gibt Instrumente mit Wartungserinnerungen",
  "integration": "Integration",
  "invalidDate": "Ungültiges Datum",
  "invalidOutlookLink": "Ungültiger iCalendar / Outlook-Link",
  "isInSimulationMode": "{{initials}} befindet sich im Simulationsmodus",
  "isSimulating": "{{initials}} simuliert...",
  "keepExistingConnections": "Bestehende Verbindungen beibehalten",
  "labelAlreadyLoaded": "Bereits geladen: {{count}}",
  "labelCreated": "Erstellt: {{count}}",
  "labelDeleted": "Gelöscht: {{count}}",
  "labelDeletedOrFinished": "Gelöscht oder als abgeschlossen markiert: {{count}}",
  "labelDoneDeleted": "Erledigt/Gelöscht: {{count}}",
  "labelUpdatedInformation": "Aktualisierte Informationen: {{count}}",
  "lastErrorLog": "Letztes Fehlerprotokoll",
  "lastWeek": "Letzte Woche",
  "latestArrival": "Späteste Ankunft",
  "leadTimesInWorkDays": "Vorlaufzeiten in Arbeitstagen",
  "leaveEmptyIfNotUsed": "(leer lassen, wenn nicht verwendet)",
  "leaveEmptyIfNotUsedDefault": "(leer lassen, wenn nicht verwendet, Standard={{defaultValue}})",
  "loadFromTemplate": "Aus Vorlage laden",
  "loading": "WIRD GELADEN",
  "loadingEllipsis": "Laden...",
  "loadingSamples": "Proben werden geladen",
  "loadingSheet": "Blatt wird geladen",
  "loadingSheets": "Blätter werden geladen",
  "location": "Standort",
  "locationColon": "Standort: {{name}}",
  "locationName": "Standortname",
  "lockItemType": "{{itemType}} sperren",
  "lockSamples": "Proben sperren",
  "lockUnlockSamplesLabel": "Proben sperren/entsperren:",
  "locks": "Sperren",
  "locksAllFutureAnalysisTasks": "Sperrt alle zukünftigen geplanten Analyseaufgaben",
  "locksAllFutureProjectActions": "Sperrt alle zukünftigen geplanten Projektaktionen",
  "login": "Anmelden",
  "logout": "Abmelden",
  "maintenanceCreatedSuccessfully": "Wartung \"{{name}}\" erfolgreich erstellt",
  "maintenanceDeletedSuccessfully": "Wartung \"{{name}}\" erfolgreich gelöscht",
  "maintenanceExpired": "Wartung abgelaufen",
  "maintenanceExpiresInDays": "Wartung läuft in weniger als {{days}} Tagen ab",
  "maintenanceMarkedAsCompleted": "Wartung \"{{name}}\" als abgeschlossen markiert",
  "maintenanceName": "Wartungsname",
  "maintenanceUpdatedSuccessfully": "Wartung \"{{name}}\" erfolgreich aktualisiert",
  "mandatoryIfRecurrenceUsed": "(erforderlich, wenn Wiederholung verwendet wird)",
  "manualSample": "Manuelle Probe",
  "manualSheetConfiguration": "Manuelle Blattkonfiguration",
  "markAsDone": "Als erledigt markieren",
  "maxSampleCount": "Maximale Probenanzahl",
  "maxSampleCountLabel": "Max. Probenanzahl: ",
  "maxTimeBetweenActions": "Maximale Zeit zwischen Aktionen (DD:HH:MM)",
  "maxTimeBetweenTasks": "Maximale Zeit zwischen Aufgaben (DD:HH:MM)",
  "member": "Mitglied",
  "memberHasEnabledICalendarOutlookIntegration": "Mitglied hat iCalendar / Outlook-Integration aktiviert",
  "memberHasEnabledOutlook": "Mitglied hat iCalendar / Outlook-Integration aktiviert",
  "memberPermissions": "Mitgliedsberechtigungen",
  "memberPlan": "Mitgliedsplan",
  "memberTime": "Mitgliedszeit",
  "membersGoDirectlyToMemberPlan": "Mitglieder gehen direkt zum Mitgliedsplan",
  "message": "Nachricht",
  "metric": "Kennzahl",
  "minSampleCount": "Minimale Probenanzahl",
  "minSampleMustBeLowerThanMax": "Die minimale Probenanzahl muss kleiner als die maximale Probenanzahl sein",
  "minTimeBetweenActions": "Minimale Zeit zwischen Aktionen (DD:HH:MM)",
  "minTimeBetweenTasks": "Minimale Zeit zwischen Aufgaben (DD:HH:MM)",
  "minTimeMustBeSmallerThanMax": "Die minimale Zeitspanne muss kleiner als die maximale Zeitspanne sein",
  "minimumDuration": "Mindestdauer: {{time}}",
  "minute": "Minute",
  "missingPasswordRequirements": "Fehlende Passwortanforderungen: {{requirements}}",
  "months": "Monate",
  "movedBy": "Verschoben von",
  "movedFrom": "Verschoben von",
  "movedTo": "Verschoben nach",
  "mustBeIcsLink": "Muss ein .ics-Link sein",
  "name": "Name",
  "namePerformer": "{{name}} Ausführender",
  "nameTooLongTitle": "Name zu lang (maximal 100 Zeichen)",
  "newAnalysisTaskBundle": "Neues Analyseaufgaben-Bundle",
  "newChat": "Neuer Chat",
  "newInstrument": "Neues Instrument",
  "newProject": "Neues Projekt",
  "newProjectTemplateDraft": "Neuer Projektvorlagen-ENTWURF",
  "newStart": "Neuer Start",
  "nextDay": "Nächster Tag",
  "nextWeek": "Nächste Woche",
  "no": "Nein",
  "noAnalysesForProduct": "Für dieses Produkt wurden keine Analysen gefunden.",
  "noAssetsFound": "Keine Assets gefunden",
  "noChanges": "Keine Änderungen",
  "noChatbotSelected": "Kein Chatbot ausgewählt",
  "noDataFound": "Keine Daten gefunden",
  "noErrorsToDisplay": "Keine Fehler zur Anzeige.",
  "noGroup": "Keine Gruppe",
  "noMembersLoaded": "Es wurden keine Mitglieder geladen.",
  "noOfRecurrences": "Anz. Wiederholungen",
  "noReferencesAvailable": "Keine Referenzen verfügbar.",
  "noSamples": "Keine Proben",
  "noSamplesAvailable": "Keine Proben verfügbar",
  "noSearchResults": "Keine Suchergebnisse",
  "noTimeLimitUnlessSpecified": "Keine Zeitbegrenzung, sofern nicht angegeben",
  "none": "Keine",
  "default": "Standard",
  "notAvailable": "N/V",
  "notEnoughRoomForDuration": "Nicht genug Platz für die Dauer",
  "notStarted": "Nicht gestartet",
  "numberOfObservations": "Anzahl der Beobachtungen",
  "numberOfRecurrences": "Anzahl der Wiederholungen",
  "numericInputBetweenTimeRange": "Bitte geben Sie eine numerische Eingabe zwischen 00:00 und 23:59 ein",
  "offsiteCalendar": "OFFSITE-Kalender",
  "ok": "OK",
  "oldInstrument": "Altes Instrument",
  "oldStart": "Alter Start",
  "onlyAdvancedUsersInfo": "Nur fortgeschrittene Benutzer verwenden sowohl frühesten Start als auch Verbindungen",
  "onsite": "Vor Ort",
  "openReferences": "Referenzen öffnen",
  "operationalGreyTaskTimePercentage": "Prozentsatz der operativen GreyTask-Zeit im Verhältnis zur Gesamtzeit (OG2T)",
  "operationalTask": "Operative Aufgabe",
  "otherPlannerSimulating": "{{initials}} befindet sich im Simulationsmodus",
  "outlookLinkLabel": "iCalendar / Outlook-Link",
  "outputLastMonth": "Ausgang letzter Monat",
  "outputThisMonth": "Ausgang diesen Monat",
  "parentColumn": "Übergeordnete Spalte",
  "password": "Passwort",
  "paused": "Pausiert",
  "peopleSetup": "Personaleinrichtung",
  "perSampleDuration": "Dauer pro Probe (HH:MM:SS)",
  "perSampleDurationForPeopleSetup": "Dauer pro Probe für Personaleinrichtung",
  "performerConstraintsCount": "Anzahl der Ausführenden-Beschränkungen",
  "performerConstraintsLabel": "Ausführenden-Beschränkungen",
  "permanentApiToken": "Permanentes API-Token",
  "permanentApiTokenDescription": "Dies ist ein permanentes API-Token, mit dem Sie über unsere API auf Ihr Team zugreifen können. Kopieren Sie es und bewahren Sie es an einem sicheren Ort auf.",
  "pinConversation": "Konversation anheften",
  "planned": "Geplant",
  "planner": "Planer",
  "plannertechLanguage": "Plannertech-Sprache",
  "plannertechVariable": "Plannertech-Variable",
  "pleaseChooseColor": "Bitte wählen Sie eine Farbe für die Analyse aus",
  "pleaseFillOutAnalysisName": "Bitte füllen Sie den Analyse-Namen aus",
  "pleaseFillOutRequiredTaskParams": "Bitte füllen Sie die erforderlichen Aufgabenparameter aus",
  "pleaseGiveEmptyOrFullInput": "Bitte geben Sie entweder leer oder vollständig ein",
  "pleaseGiveNumericInput": "Bitte geben Sie eine numerische Eingabe ein",
  "pleaseInputValidDate": "Bitte geben Sie ein gültiges Datum ein",
  "pleaseSelectAtLeastOneItem": "Bitte wählen Sie mindestens ein Element aus",
  "pleaseSelectColor": "Bitte wählen Sie eine Farbe aus",
  "pleaseSelectFirstDay": "Bitte wählen Sie den ersten Tag aus.",
  "pleaseSelectLastDay": "Bitte wählen Sie den letzten Tag aus.",
  "pleaseSelectTimezone": "Bitte wählen Sie eine Zeitzone aus",
  "previousDay": "Vorheriger Tag",
  "primary": "Primär",
  "primaryInstrument": "Primäres Instrument",
  "prioritizeByDeadline": "IAP nach Frist priorisieren",
  "prioritizeByPriority": "IAP nach Prioritätsnummer priorisieren",
  "priority": "Priorität",
  "priorityHigh": "(Hoch)",
  "priorityLow": "(Niedrig)",
  "priorityMedium": "(Mittel)",
  "process": "Verarbeiten",
  "processed": "Verarbeitet",
  "processing": "Wird verarbeitet...",
  "processingInProgress": "Verarbeitung läuft",
  "productName": "Produktname",
  "project": "Projekt",
  "projectActions": "Projektaktionen",
  "projectBatchNumber": "Projektchargennummer",
  "projectDeadline": "Projektfrist",
  "projectDescription": "Projektbeschreibung",
  "projectEarliestStart": "Frühester Projektstart",
  "projectGroup": "Projektgruppe",
  "projectGroupName": "Name der Projektgruppe",
  "projectImport": "Projektimport",
  "projectImportVariable": "Projektimport-Variable",
  "projectMaterialDescription": "Projektmaterialbeschreibung",
  "projectMaterialNumber": "Projektmaterialnummer",
  "projectName": "Projektname",
  "projectPriority": "Projektpriorität",
  "projectReleaseDate": "Projektfreigabedatum",
  "projectSupplierName": "Projektlieferantenname",
  "projectSupplierNumber": "Projektlieferantennummer",
  "projectTemplate": "Projektvorlage",
  "projectTemplates": "Projektvorlagen",
  "projectTimePercentage": "Prozentsatz der Projektzeit im Verhältnis zur Gesamtzeit (P2T)",
  "projectView": "Projektansicht",
  "projects": "Projekte",
  "projectsAndActions": "Projekte & Aktionen",
  "promptPrefix": "Prompt-Präfix",
  "promptTooLongTitle": "Prompt zu lang (maximal 1200 Zeichen)",
  "publish": "VERÖFFENTLICHEN",
  "publishSimulationChanges": "Änderungen des Simulationsmodus veröffentlichen",
  "qcLibrarian": "QC Librarian",
  "qcLibrarianTitle": "QC Librarian 3.8",
  "recur": "Wiederholen",
  "recurEvery": "Wiederholen alle",
  "recurrence": "Wiederholung",
  "reduce": "Reduzieren",
  "references": "Referenzen",
  "rejectedFileTypes": "Abgelehnte Dateitypen",
  "rejectedFilesIncompatible": "Die folgenden Dateien wurden aufgrund inkompatibler Formate abgelehnt",
  "reminderDaysBeforeEndDate": "Erinnerung (Tage vor Enddatum)",
  "remove": "Entfernen",
  "removeAnalysisFromProduct": "{{name}} von diesem Produkt entfernen",
  "removeAsset": "Asset entfernen",
  "removeEverything": "Alles entfernen",
  "removeInstrument": "Instrument entfernen",
  "reportGenerator": "Berichtsgenerator",
  "reports": "Berichte",
  "repositories": "Repositories",
  "repositoryCurrentlyProcessing": "Das Repository verarbeitet derzeit die Dateien. Bitte aktualisieren Sie die Seite, um den Fortschritt zu sehen",
  "repositoryHasUnprocessedFiles": "Dieses Repository hat unverarbeitete Dateien",
  "repositoryIsProcessed": "Dieses Repository ist verarbeitet",
  "repositoryName": "Repository-Name",
  "reset": "Zurücksetzen",
  "role": "Rolle",
  "row": "Zeile",
  "rowNumber": " Zeile {{row}}",
  "runIAP": "IAP ausführen",
  "runningIAP": "IAP wird ausgeführt",
  "sampleAnalysisName": "Probenanalyse-Name",
  "sampleBatchNumber": "Probenchargennummer",
  "sampleHighestPriority": "Die Probe hat die höchste Priorität",
  "sampleId": "Proben-ID",
  "sampleIdWithValue": "Proben-ID: {{id}}",
  "sampleImport": "Probenimport",
  "sampleImportVariable": "Probenimport-Variable",
  "sampleInProgressOnDoneAnalysis": "Probe in Bearbeitung bei abgeschlossener Analyse",
  "sampleIsDone": "Die Probe ist abgeschlossen",
  "sampleLog": "Probenprotokoll",
  "sampleLowestPriority": "Die Probe hat die niedrigste Priorität",
  "sampleMaterialNumber": "Probenmaterialnummer",
  "sampleName": "Probenname",
  "sampleObservation": "Probenbeobachtung",
  "sampleObservations": "Probenbeobachtungen",
  "samplePercentage": "Probenanteil",
  "sampleProductDescription": "Produktbeschreibung der Probe",
  "sampleReceivedDate": "Eingangsdatum der Probe",
  "sampleStatus": "Probenstatus",
  "sampleView": "Probenansicht",
  "samples": "Proben",
  "samplesWithName": "Proben mit dem Namen {{name}}",
  "samplesWithoutProduct": "Proben ohne Produkt",
  "save": "Speichern",
  "saveAs": "Speichern unter",
  "saveAsDraft": "Als {{type}}-ENTWURF speichern",
  "saveAsNew": "Als neu speichern",
  "saveAsNewAnalysis": "Als neue Analyse speichern",
  "saveAsNewTemplate": "Als neue Vorlage speichern",
  "saveAsType": "Als {{type}} speichern",
  "scrollToTop": "Nach oben scrollen",
  "scrumView": "Scrum-Ansicht",
  "scrumViewOrdering": "Sortierung der Scrum-Ansicht",
  "searchBySampleName": "Nach Probennamen suchen...",
  "searchCountry": "Land suchen",
  "seats": "Sitze",
  "second": "Sekunde",
  "secondaryInstrumentMustHaveAllowedInstrument": "Die sekundäre Instrumenteinrichtung muss mindestens ein erlaubtes Instrument haben",
  "selectAll": "Alle auswählen",
  "selectChatbot": "Chatbot auswählen",
  "selectDefaultChatbot": "Standard-Chatbot auswählen",
  "selectEntireDay": "Gesamten Tag auswählen",
  "selectEntireWorkday": "Gesamten Arbeitstag auswählen",
  "selectLocation": "Standort auswählen...",
  "selectSamples": "Proben auswählen",
  "selectState": "Status auswählen...",
  "selectTimezone": "Zeitzone auswählen...",
  "selectType": "Typ auswählen",
  "selectedFilesReadyForSubmit": "Ausgewählte Dateien/Ordner bereit zum Absenden:",
  "selectedProduct": "Ausgewähltes Produkt",
  "setPlannedValues": "Geplante Werte festlegen",
  "settings": "Einstellungen",
  "settingsForQcLibrarian": "Einstellungen für QC Librarian",
  "setupTimeForPeopleSetup": "Rüstzeit für Personaleinrichtung",
  "setuptime": "Rüstzeit (HH:MM)",
  "sheetName": "Blattname",
  "sheetNameLabel": "Blattname",
  "sheetType": "Blatttyp",
  "shouldBeEqualTo": "sollte gleich sein wie",
  "shouldNotBeEqualTo": "sollte nicht gleich sein wie",
  "showAnalyses": "Analysen anzeigen",
  "showErrors": "Fehler anzeigen",
  "showLastErrorLog": "Letztes Fehlerprotokoll anzeigen",
  "showLibrarian": "Librarian anzeigen",
  "showLog": "Protokoll anzeigen",
  "showMore": "Mehr anzeigen",
  "showOnPlan": "Im Plan anzeigen",
  "showProjects": "Projekte anzeigen",
  "shown": "Sichtbar",
  "simulationMode": "Simulationsmodus",
  "simulationModeLogoutWarning": "Sie befinden sich derzeit im Simulationsmodus. Beim Abmelden werden die Änderungen verworfen!",
  "simulationModeOccupied": "SIMULATIONSMODUS BELEGT",
  "simulationModeUpper": "SIMULATIONSMODUS",
  "somethingWentWrong": "Etwas ist schiefgelaufen",
  "sortByProduct": "Nach Produkt sortieren",
  "sortByTime": "Nach Zeit sortieren",
  "sortByTimeDescription": "Ordnet Backlog- und Zu-erledigen-Aktionen nach ihren Fristen sowie Geplante und Abgeschlossene nach ihrer Startzeit",
  "speechToTextLanguage": "Sprache für Speech-to-Text",
  "spreadsheetColumnName": "Spaltenname im Tabellenblatt",
  "stage": "Phase",
  "standardActions": "Standardaktionen",
  "start": "Start",
  "startDate": "Startdatum",
  "startDateCheckboxInfo": "Wenn aktiviert, werden Projektfrist, Aktionsfrist und Aktionsstart relativ zum Projektstart verschoben",
  "startEndDate": "Start-/Enddatum",
  "startProcessingInfo": "Dadurch wird die Verarbeitung des Repositorys gestartet. Je nach Grösse des Repositorys kann dies eine Weile dauern",
  "startRecurrence": "Wiederholung starten",
  "startTime": "Startzeit",
  "started": "Gestartet",
  "state": "Status",
  "status": "Status",
  "submit": "Absenden",
  "successfullyLoaded": "Erfolgreich geladen: {{members}}",
  "successfullyUploadedFiles": "Erfolgreich hochgeladene Dateien",
  "systemPrompt": "System-Prompt",
  "taskBelongsToTeam": "Aufgabe gehört zu Team: {{team}}",
  "taskCount": "Anzahl Aufgaben",
  "taskDesignTool": "Aufgaben-Design-Tool",
  "taskLog": "Aufgabenprotokoll",
  "taskName": "Aufgabenname",
  "taskPerformerConstraints": "Ausführenden-Beschränkungen der Aufgabe",
  "tasks": "Aufgaben",
  "team": "Team",
  "teamChatbot": "Team-Chatbot",
  "teamLabel": "Team: {{name}}",
  "teamMember": "Teammitglied",
  "teamName": "Teamname",
  "teamPlan": "Teamplan",
  "teamUsageTitle": "{{name}} Auslastung",
  "teams": "Teams",
  "templateIsDraft": "Diese Projektvorlage ist ein Entwurf",
  "templateName": "Vorlagenname",
  "theProjectIsDone": "Das Projekt ist abgeschlossen",
  "timeConstraints": "Zeitbeschränkungen",
  "timeHHMM": "Zeit (HH:MM)",
  "timePeriod": "Zeitraum",
  "timestamp": "Zeitstempel",
  "timezone": "Zeitzone",
  "to": "Bis",
  "toConfirmDeletionType": "Zur Bestätigung der Löschung {{keyword}} eingeben",
  "toConfirmDeletionTypeDeleteData": "Geben Sie zur Bestätigung der Löschung {{keyword}} ein und drücken Sie auf Bestätigen. Dadurch werden die Testdaten dauerhaft gelöscht, auch im Simulationsmodus. Es gibt kein Zurück.",
  "toConfirmDeletionTypeKeyword": "Zur Bestätigung der Löschung {{keyword}} eingeben und Bestätigen drücken",
  "toDate": "Bis-Datum",
  "toDo": "Zu erledigen",
  "toTime": "Bis-Zeit (HH:MM)",
  "toTimeHH": "Bis-Zeit (HH)",
  "toTimeHHMM": "Bis-Zeit (HH:MM)",
  "today": "Heute",
  "tokens": "Token",
  "total": "Gesamt",
  "normalSeats": "Normal",
  "tryReloadingOrContactSupport": "Versuchen Sie, neu zu laden, oder kontaktieren Sie den Support, wenn das Problem weiterhin besteht!",
  "type": "Typ",
  "typeBeforeConfirming": "{{keyword}} vor der Bestätigung eingeben",
  "typeOrSelect": "Eingeben oder auswählen...",
  "typeYourMessage": "Geben Sie Ihre Nachricht ein...",
  "unassignedSamples": "Nicht zugewiesene Proben",
  "unassignedSamplesFor": "Nicht zugewiesene Proben für \"{{name}}\"",
  "unflag": "Markierung entfernen",
  "unflagSample": "Markierung der Probe entfernen",
  "unlockItemType": "{{itemType}} entsperren",
  "unlockSamples": "Proben entsperren",
  "unlocks": "Entsperrt",
  "unlocksAllFutureAnalysisTasks": "Entsperrt alle zukünftigen geplanten Analyseaufgaben",
  "unlocksAllFutureProjectActions": "Entsperrt alle zukünftigen geplanten Projektaktionen",
  "unnamed": "unbenannt",
  "unpinConversation": "Anheftung der Konversation lösen",
  "unplan": "Aus der Planung entfernen",
  "unplanAnalysis": "Analyse aus der Planung entfernen",
  "unplanItemType": "{{itemType}} aus der Planung entfernen",
  "unplanSample": "Probe aus der Planung entfernen",
  "unplanSelected": "Ausgewählte aus der Planung entfernen",
  "unplanned": "Ungeplant",
  "unplannedProjects": "Ungeplante Projekte",
  "unsavedChangesIn": "Es gibt ungespeicherte Änderungen in:",
  "updateIntegration": "Integration aktualisieren",
  "updatedIcalOutlook": "iCalendar / Outlook aktualisiert!",
  "uploadAborted": "Upload abgebrochen!",
  "uploadComplete": "Upload abgeschlossen!",
  "uploadFailedForFile": "Upload für Datei fehlgeschlagen: {{path}}",
  "uploadFinished": "Upload abgeschlossen!",
  "uploadTo": "Zu {{name}} hochladen",
  "usage": "Nutzung",
  "used": "Verwendet",
  "usedAssets": "Verwendete Assets",
  "usedInstrument": "Verwendetes Instrument",
  "usedInstruments": "Verwendete Instrumente",
  "username": "Benutzername",
  "value": "Wert",
  "view": "Ansicht",
  "viewAllAnalysesForProduct": "Alle Analysen für dieses Produkt anzeigen",
  "viewAnalysisSamples": "Analyseproben anzeigen",
  "viewCompact": "Kompakt anzeigen",
  "viewNormal": "Normal anzeigen",
  "weekNumber": "Woche {{week}}",
  "weekView": "Wochenansicht",
  "dayView": "Tagesansicht",
  "weekendView": "Wochenendansicht",
  "screen": "Bildschirm",
  "clickToSortBy": "Klicken Sie, um nach {{column}} zu sortieren",
  "fileChangedPleaseReselect": "{{file}} wurde geändert. Bitte wählen Sie die Datei erneut aus",
  "contentTooWideZoomOut": "Der Inhalt ist zu breit für den Bildschirm. Für eine bessere Ansicht zoomen Sie heraus ({{key}} +/-)",
  "week": "Woche",
  "weekly": "Wöchentlich",
  "weeks": "Woche(n)",
  "withConnections": "mit Verbindungen",
  "workHours": "Arbeitszeiten",
  "workWeek": "Arbeitswoche",
  "years": "Jahre",
  "yes": "Ja",
  "youAreInSimulationMode": "Sie befinden sich im Simulationsmodus",
  "zeroHours": "0 Stunden",
  "addCustomer": "Kunden hinzufügen",
  "addGlobalChatbot": "Globalen Chatbot hinzufügen",
  "addGlobalRepository": "Globales Repository hinzufügen",
  "apiKey": "API-Schlüssel",
  "authenticationCode": "Authentifizierungscode",
  "authenticationCodeSentInfo": "Wir haben einen Authentifizierungscode an Ihre E-Mail gesendet. Bitte geben Sie ihn oben vor der Anmeldung ein",
  "chatbotPrefix": "Chatbot-Präfix",
  "chatbotSystemPrompt": "Chatbot-System-Prompt",
  "chatbotSystemPrompts": "Chatbot-System-Prompts",
  "citationGuidelines": "Zitier-Richtlinien",
  "configureMember": "Mitglied konfigurieren",
  "createApiKey": "API-Schlüssel erstellen",
  "creatingProject": "Projekt wird erstellt",
  "currentQuestion": "Aktuelle Frage",
  "customerAdminApiKeyForGlobalRepositories": "Customer-Admin-API-Schlüssel für globale Repositories",
  "dateFormatYyyyMmDd": "YYYY-MM-DD",
  "deleteApiKey": "API-Schlüssel löschen",
  "descriptionPrompt": "Beschreibungs-Prompt",
  "editGlobalMessage": "Globale Nachricht bearbeiten",
  "editingProject": "Projekt wird bearbeitet",
  "editSystemPrompts": "System-Prompts bearbeiten",
  "filePathPrompt": "Dateipfad-Prompt",
  "fillingInSamples": "Proben werden aufgefüllt",
  "generalPrefix": "Allgemeines Präfix",
  "globalChatbots": "Globale Chatbots",
  "globalRepositories": "Globale Repositories",
  "hideNextWeek": "Nächste Woche ausblenden",
  "hideSatSun": "- Sa/So",
  "manageAdmins": "Admins verwalten",
  "oneWeek": "1 Woche",
  "openMetricsPanel": "Kennzahlen-/IAP-Panel öffnen",
  "openTodoList": "TODO-Liste öffnen",
  "optimizedQuestionPrompt": "Optimierter Fragen-Prompt",
  "plannertech": "Plannertech",
  "plannertechSuite": "Plannertech Suite",
  "plannertechTeamPlan": "Plannertech Team Plan",
  "previousConversation": "Vorherige Konversation",
  "librarianLogoAlt": "Librarian-Logo",
  "qcLibrarianForCompany": "{{company}} QC Librarian",
  "relevantDocumentation": "Relevante Dokumentation",
  "repositoryHasUnprocessedFilesInfo": "In diesem Repository gibt es unverarbeitete Dateien",
  "repositoryIsEmpty": "Dieses Repository ist leer",
  "repositoryPrefix": "Repository-Präfix",
  "repositoryProcessingInProgressInfo": "Das Repository verarbeitet derzeit die Dateien. Bitte aktualisieren Sie die Seite, um den Fortschritt zu sehen",
  "sampleAllocation": "Probenzuweisung",
  "mbWithValue": "{{value}} MB",
  "seatsWithCount": "Sitze: {{count}}",
  "excludingToday": "Ohne heute",
  "unplanning": "Wird aus der Planung entfernt",
  "activeSeats": "Aktive Sitze: {{count}}",
  "totalSeats": "Normale Sitze: {{count}}",
  "purchasedSeats": "Gekaufte Sitze: {{count}}",
  "globalMessage": "Globale Nachricht",
  "clearGlobalMessageConfirm": "Sind Sie sicher, dass Sie die globale Nachricht leeren möchten? Dadurch verschwindet sie für alle Benutzer.",
  "samplesCount": "Proben: {{count}}",
  "locations": "Standorte",
  "customers": "Kunden",
  "editCustomer": "Kunde bearbeiten",
  "addCustomerTitle": "Kunde hinzufügen",
  "deleteCustomer": "Kunde löschen",
  "customerName": "Kundenname",
  "customerStatus": "Kundenstatus",
  "active": "Aktiv",
  "passive": "Passiv",
  "allowedDomains": "Erlaubte Domains",
  "allowedPerformers": "Erlaubte Ausführende",
  "seatsPurchased": "Gekaufte Sitze",
  "customerApiKey": "Kunden-API-Schlüssel",
  "durationFormatDDHH": "DD:HH",
  "durationFormatHHMMSS": "HH:MM:SS",
  "durationFormatHHMM": "HH:MM",
  "durationFormatHH": "HH",
  "durationFormatDDHHMM": "DD:HH:MM",
  "continue": "Weiter",
  "showNextWeek": "Nächste Woche anzeigen",
  "showSatSun": "+ Sa/So",
  "topDescriptionPrompt": "Oberer Beschreibungs-Prompt",
  "twoWeeks": "2 Wochen",
  "updateHelpPage": "Hilfeseite aktualisieren",
  "userAlreadyLoggedInTakeOver": "Benutzer ist bereits angemeldet. Um die Sitzung zu übernehmen, drücken Sie auf Bestätigen",
  "zoomIn": "Hineinzoomen",
  "zoomOut": "Herauszoomen",
  "constraintWarningTitle": "{{count}} Warnung(en) sind aufgetreten",
  "assetStatusFree": "Frei",
  "assetStatusBooked": "Gebucht",
  "dateTo": "bis",
  "futureAnalysisTaskCantBeFinished": "Eine zukünftige Analyseaufgabe kann nicht abgeschlossen werden",
  "tableNotFound": "Tabelle nicht gefunden",
  "conversionSheetFilename": "Konvertierungsblatt.xlsx",
  "selectTeam": "Select a team to log in to",
  "admin": "Admin",
  "customerAdmin": "Kundenadmin",
  "attachFile": "Datei anhängen",
  "removeFile": "Datei entfernen",
  "fileTooLarge": "Datei ist zu groß (max. 10 MB)",
  "tooManyFiles": "Maximal 3 Dateien pro Nachricht",
  "unsupportedFileType": "Nicht unterstützter Dateityp. Erlaubt: PDF, DOCX, TXT, CSV, PNG, JPG, GIF, WEBP"
}
